/**
 * Горизонти планування. Реалізація на `Temporal.PlainDate` за [ADR-0013]:
 * горизонту потрібна дата **без часу й без зони**, бо 2026-08-24 має бути
 * тим самим днем у Києві й у Лісабоні.
 */
/** Від найширшого до найвужчого. Порядок значущий: на ньому будується зум. */
export const SCALES = ["year", "month", "week", "day"];
export class HorizonError extends Error {
    constructor(message) {
        super(message);
        this.name = "HorizonError";
    }
}
//# sourceMappingURL=types.js.map